import { z } from "zod";
//#region src/api/orpc/image/lora.ts
/**
* A single LoRA attachment in an image creation request.
*
*   - `modelId`      — the LoRA's generation model version id.
*   - `weight`       — 0..1 strength multiplier (defaults to 1).
*   - `triggerWords` — optional override; if omitted the server looks them
*                      up from the LoRA's metadata at request time.
*/
const LoraItemSchema = z.object({
	modelId: z.string().min(1),
	weight: z.number().min(0).max(1).default(1),
	triggerWords: z.string().optional()
});
//#endregion
export { LoraItemSchema };
